/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.kit.KitProvisioningAuthority
*/
export var KitProvisioningAuthority;
(function (KitProvisioningAuthority) {
    KitProvisioningAuthority["NOTIFY"] = "NOTIFY";
    KitProvisioningAuthority["UPDATE"] = "UPDATE";
    KitProvisioningAuthority["MANAGE"] = "MANAGE";
})(KitProvisioningAuthority || (KitProvisioningAuthority = {}));
//# sourceMappingURL=KitProvisioningAuthority.js.map